import { OverrideCustomElementConfig } from "@cervval.js/client-html5-core/src/components/customElement.types";
import { createHtmlElement } from "@cervval.js/client-html5-core/src/tools/dom.tools";
import { CustomElement } from "@cervval.js/client-html5-spa/navigation";
import { CheckboxMode } from "@cervval.js/client-html5-ui/src/components/checkbox/checkbox";
import { CjsDialog, DialogPreConfig, DialogSize } from "@cervval.js/client-html5-ui/src/components/dialog/dialog";
import { CjsCheckboxEditor } from "@cervval.js/client-html5-ui/src/editors/checkboxEditor/checkboxEditor";
import { CGV_PRO } from "@sportsante/common-shared/src/data/cgv/cgv";
import { AcceptTerms } from "../acceptTerms/acceptTerms";
import { I18nCgvCheckbox } from "./cgvCheckbox.i18n";

@CustomElement({
    name: "cgv-checkbox",
    style: require("./cgvCheckbox.scss"),
    i18n: require("./cgvCheckbox.i18n").i18nCgvCheckbox
})
export class CgvCheckbox<I18n extends I18nCgvCheckbox = I18nCgvCheckbox> extends CjsCheckboxEditor {

    public override readonly i18n!: I18n;

    constructor(customElementOptions?: OverrideCustomElementConfig) {
        super(undefined, undefined, customElementOptions);
    }

    /** @override */
    public override init(): void {
        super.init();

        const triggerCguDisplay = createHtmlElement("span", { innerHTML: "Voir les Conditions Générales de Vente", cssClass: ["form-check", "trigger-cgv"] });
        triggerCguDisplay.addEventListener("click", () => {

            const dialog = new CjsDialog({
                title: this.i18n.cgv,
                size: DialogSize.EXTRA_LARGE,
                preConfig: DialogPreConfig.NO_BUTTON,
                enableDismiss: true,
                onCloseButtonClick: () => {
                    this.setValue(false);
                    return Promise.resolve({ preventClose: false });
                },
                openOnInit: false,
                enableDraggable: false
            });

            dialog.classList.add("dialog-accept-terms-form");

            const acceptTerms = new AcceptTerms({
                terms: CGV_PRO,
                acceptCallback: () => {
                    // Disable checkbox and button in case the network is slow to prevent user from interacting again
                    acceptTerms.disableElements();
                    this.setValue(true);
                    dialog.hide();
                }
            });


            dialog.addToBody(
                acceptTerms
            );
            acceptTerms.components.acceptButton.options.setAndRefreshIfChanged({ label: this.i18n.back });

            dialog.show();

        });
        this.getInput().components.formCheckContainer.insertAdjacentElement("afterend", triggerCguDisplay);

        this.changeEvent.on(() =>
            this.setValidationError(undefined)
        );

        this.getInput().options.setAndRefreshIfChanged({
            mode: CheckboxMode.CHECKBOX,
            color: "#045E53",
            enableIndeterminate: false,
            enableLabelClick: true,
            label: this.i18n.checkboxLabel
        });
    }

    /** Set a generic validation error on component inciting the user to accept terms of service to continue a process */
    public setCgvValidationError(): void {
        this.setValidationError({ errorMessage: this.i18n.validationError });
    }
}